// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonMapOptionsMapping.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import { MappingValues } from 'logic/data/Izenda.ChartDefaultConfig';

const { HORIZONTAL_ALIGN_VALUES, VERTICAL_ALIGN_VALUES } = MappingValues;

export default {
  optionsByType: {
    izValueLabel: { propKey: 'izendaOptions.dataLabels', defaultValue: false },
    izShowTooltip: { propKey: 'tooltip.enabled', defaultValue: true },
    izMapLabel: { propKey: 'izendaOptions.mapLabel', defaultValue: false },
    'izMapNavigation.enabled': { propKey: 'mapNavigation.enabled', defaultValue: false },
    'izMapNavigation.align': {
      propKey: 'mapNavigation.buttonOptions.align',
      propSource: HORIZONTAL_ALIGN_VALUES,
      defaultValue: undefined
    },
    'izMapNavigation.verticalAlign': {
      propKey: 'mapNavigation.buttonOptions.verticalAlign',
      propSource: VERTICAL_ALIGN_VALUES,
      defaultValue: undefined
    },
    legendSettings: { defaultValue: true }
  }
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartMap/Izenda.CommonMapOptionsMapping.js